export enum ColorType {
  PRIMARY   = 'primary',
  SECONDARY = 'secondary'
}
